import memoize from 'lodash/memoize';

export default async function fetchJSON(url: string, settings?: any) {
    const response = await fetch(url, settings);
    return response.json();
}

fetchJSON.memoized = memoize(
    fetchJSON,
    (url, settings) => JSON.stringify([url, settings])
);
